const subscription_info = state => state.subscription_info;
const subscription_detail = state => state.subscription_detail;
const subscription_records = state => state.subscription_records;

export {
    subscription_info,
    subscription_detail,
    subscription_records,
}
